import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";
import { useDebouncedSyncedString } from "../useDebouncedSyncedString";

export function EmailStepFields({
  step,
  onStepDataChange,
  onEditEmailBody,
}: {
  step: AutomationStep;
  onStepDataChange: StepNodeData["onStepDataChange"];
  onEditEmailBody: StepNodeData["onEditEmailBody"];
}) {
  const subjectField = useDebouncedSyncedString({
    syncKey: step.id,
    externalValue: step.data?.subject || "",
    onCommit: ({ value }) => onStepDataChange({ stepId: step.id, field: "subject", value }),
  });

  return (
    <div className="p-4 space-y-3 nodrag" onPointerDownCapture={(e) => e.stopPropagation()}>
      <div>
        <div className="text-xs font-medium text-emerald-700 mb-1.5">Subject</div>
        <Input
          placeholder="Email subject..."
          value={subjectField.draft}
          onChange={subjectField.onChange}
          onBlur={subjectField.onBlur}
          onFocus={subjectField.onFocus}
          className="text-sm"
        />
      </div>
      <div>
        <div className="text-xs font-medium text-emerald-700 mb-1.5">Body (HTML)</div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className={`w-full justify-start gap-2 text-sm ${!(step.data?.body?.trim()) ? "border-amber-300 border-dashed text-amber-700" : ""}`}
          onClick={() => onEditEmailBody(step.id)}
        >
          <Pencil className="h-4 w-4" />
          {step.data?.body?.trim() ? "Edit" : "Add body"}
        </Button>
      </div>
    </div>
  );
}
